import { Flex, Text, type FlexProps } from '@chakra-ui/react';
import { SparksSolid } from 'iconoir-react';
import type { ReactNode } from 'react';

/** The onboarding tagline badge, also used to introduce auth news. */
export const OnboardingTaglineBadge = ({
  children,
  color,
  borderWidth = 0,
}: {
  children: ReactNode;
  color: FlexProps['color'];
  borderWidth?: FlexProps['borderWidth'];
}) => (
  <Flex
    alignSelf="flex-start"
    align="center"
    w="fit-content"
    gap="8px"
    h="40px"
    px="16px"
    borderRadius="full"
    bg="primary.900"
    borderWidth={borderWidth}
    borderColor="announcement.surfaceBorder"
    color={color}
  >
    <SparksSolid width={16} height={16} aria-hidden />
    <Text fontFamily="heading" fontSize="15px" fontWeight="600">
      {children}
    </Text>
  </Flex>
);
